<template>
  <div class="header">
    <div><span v-if="required" class="red">*</span>{{ title }}</div>
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
.red {
  color: hsl(0, 100%, 67%);
  padding-right: 10px;
}
.header {
  font-weight: bold;
  padding: 10px;
  // padding-left: 70px;
  // padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
